import { Injectable } from '@angular/core';
import { FloorAcl, FloorAclGroups, FloorAclMembers, SecurityService } from '@era/locations-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';
import {
  FloorPermissionsResolverActions,
  AccessControlListApiActions,
  FloorAclPermissionsUiActions,
} from './floor-acl.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class FloorAclEffects {
  constructor(
    private readonly securityService: SecurityService,
    private readonly actions$: Actions
  ) {}

  groupLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorPermissionsResolverActions.floorAclRequested),
      mergeMap(({ resourceId, locationResourceId }) =>
        safeMap(
          this.securityService.getFloorAcls(resourceId, locationResourceId),
          (floorAcl: FloorAcl) => AccessControlListApiActions.floorAclLoaded({ floorAcl }),
          (error) => AccessControlListApiActions.floorAclLoadedError({ error })
        )
      )
    );
  });

  floorAclMemberPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorAclPermissionsUiActions.floorAclMemberPut),
      mergeMap(({ aclMember }) =>
        this.securityService
          .putFloorAclMembers(aclMember.resourceId, aclMember)
          .pipe(
            map((floorAclMember: FloorAclMembers) =>
              AccessControlListApiActions.floorAclMemberPut({ aclMember: floorAclMember })
            )
          )
      )
    );
  });

  floorAclGroupPutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorAclPermissionsUiActions.floorAclGroupPut),
      mergeMap(({ aclGroup }) =>
        this.securityService
          .putFloorAclGroups(aclGroup.resourceId, aclGroup)
          .pipe(
            map((floorAclGroup: FloorAclGroups) =>
              AccessControlListApiActions.floorAclGroupPut({ aclGroup: floorAclGroup })
            )
          )
      )
    );
  });

  floorAclGroupDeleteEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(FloorAclPermissionsUiActions.floorAclGroupRemove),
      mergeMap(({ aclGroup }) =>
        this.securityService
          .deleteFloorAclGroups(aclGroup.resourceId, aclGroup)
          .pipe(map(() => AccessControlListApiActions.floorAclGroupRemove({ aclGroup })))
      )
    );
  });
}
